<!---- Star of Read Device-->

@if (readDevice === 'readDevice') {
  <div class="modal configure-feature" id="myModal2" tabindex="-1" role="dialog">
    <div class="modal-dialog featureDialog" role="document">
      <div class="modal-content featureModalContent modal-content">
        <div class="row upload-container">
          @if (writingDevicesHeading) {
            <div id="read-device-multi-driver-title" class="col-3 signifyBoldmd select-file">Configure box</div>
          }
          <div class="col-9"></div>
        </div>
        <div class="row box-container-margin ">
          <div class="col-7 box-container">
            <br>
              @if (!hideStatus) {
                <div id="read-device-scanning-status" class="signifyBoldlg center-text">Scanning for reader (s)...</div>
              }
              @if (writingDevicesContainer && removeWritingHeader && !deviceCNtMatched && !incorrectBoxSize && !owpProtectedMultiDevices && !deviceNotMatching  && !configConnectedDevices && !allCorruptFeatureNotSelected && !wrongReader) {
                <div id="read-device-finding-devices-text" class="signifyBold20px center-text">Finding
                devices ...</div>
              }
              @if (writingDevicesContainer && removeWritingHeader  && !deviceCNtMatched && !incorrectBoxSize && !owpProtectedMultiDevices && !deviceNotMatching  && !configConnectedDevices && !allCorruptFeatureNotSelected && !wrongReader) {
                <div id="read-device-touch-box-text" class="signifyBooklg center-text">Please touch box on the reader...</div>
              }
              @if (readerLength?.length>0 && !hideStatus  && !deviceCNtMatched && !incorrectBoxSize && !owpProtectedMultiDevices && !deviceNotMatching  && !configConnectedDevices && !allCorruptFeatureNotSelected) {
                <div class="signifyBooklg center-text spacing">Finding <span
                class="signifyBoldlg">({{readerLength?.length}})</span> reader</div>
              }
              @if (readerLength?.length===0 && !hideStatus  && !deviceCNtMatched && !incorrectBoxSize && !owpProtectedMultiDevices && !deviceNotMatching  && !configConnectedDevices && !allCorruptFeatureNotSelected) {
                <div class="signifyBooklg center-text spacing">Finding <span
                class="signifyBoldlg">({{readerLength?.length}})</span> reader</div>
              }
              @if (customerLoader) {
                <img id="read-device-loading-spinner" src="{{pathVal}}dash-spinner.gif" class="dash-border text-secondary custom-spinner" alt="">
              }
              @if (readerData && hideStatus) {
                <div class="signifyBoldlg row">
                  <div class="col-3"></div>
                </div>
                }<br>
                @if (readerData && hideStatus && !multipleDeviceError) {
                  <div class="row">
                    <div class="col-3"></div>
                    <div id="read-device-device-row" class="col-9"><span class="signifyBoldsm">Device: </span><span
                  class="signifyBooksm">{{readerDeviceData?.deviceMetadata?.deviceName}}</span>
                &nbsp;{{readerDeviceData?.deviceMetadata?.deviceSwVersion}}</div>
              </div>
            }
            @if (readerData && hideStatus && !multipleDeviceError) {
              <div class="row">
                <div class="col-3"></div>
                <div id="read-device-12nc-row" class="col-9">
                  <span class="signifyBoldsm">12nc: </span><span
                class="signifyBooksm">{{readerDeviceData?.deviceMetadata?.device12nc}}</span>
              </div>
            </div>
          }
          @if (readerData && hideStatus && !configConnectedDevices && !multipleDeviceError) {
            <div class="row">
              <div class="col-3"></div>
              <div id="read-device-connected-count-row" class="col-9 paddingDC">
                <span class="signifyBoldsm">Devices connected: </span><span
              class="signifyBooksm">{{actualDevicesCnt}} out of {{userBoxSizeValue}}</span>
            </div>
          </div>
        }
        @if (readerData && hideStatus && incorrectBoxSize) {
          <div
            class="center-text signifyBoldlg"
            style="white-space: pre-line;"
            >
            {{ errorMessage }}
          </div>
        }
        @if (readerData && hideStatus && owpProtectedMultiDevices) {
          <div class="row">
            <div class="col-3"></div>
            <div class="col-9 paddingTp">
              <span class="signifyBoldsm"><img class="tick-img" src="{{pathVal}}caution_orange.png" alt="Caution">&nbsp;&nbsp; {{owpProtectedDevices}} out of {{outOfCount}} devices found which are OWP protected. Cannot proceed with box configuration</span>
            </div>
          </div>
        }
        @if (readerData && hideStatus && deviceNotMatching && !differentDeviceError) {
          <div
            class="center-text signifyBoldlg"
            style="white-space: pre-line;"
            >
            {{ errorMessage }}
          </div>
        }
        @if (readerData && hideStatus && differentDeviceError ) {
          <div
            class="center-text signifyBoldlg"
            style="white-space: pre-line;"
            >
            {{ errorMessage }}
          </div>
        }
        <div class="row mt-2">
          <div class="col-3"></div>
          <!--Production Info Start-->
          <div class="col-1">
            @if (readerData && hideStatus && showDeviceIDReadDC) {
              <div>
                <span class="signifyBoldsm">Device ID: </span><span class="signifyBooksm">{{deviceNfcId}}</span>
              </div>
            }
            @if (isProductionInfoAvailable && readerData && hideStatus) {
              <div>
                <span class="signifyBoldsm">Production date: </span><span
              class="signifyBooksm">{{productionDate}}</span>
            </div>
            <div>
              <span class="signifyBoldsm">Production batch ID: </span><span
            class="signifyBooksm">{{productionBatchId}}</span>
          </div>
          <div>
            <span class="signifyBoldsm">SKU: </span><span class="signifyBooksm">{{sku}}</span>
          </div>
        }
      </div>
      <!--Production Info End-->
      <div class="col-8">
        <app-supported-features-multi [initialCount]="initialCount" [outOfCount]="outOfCount"  [isFailed]="isError"></app-supported-features-multi>
      </div>
    </div>
    @if (customerLoaderAfter) {
      <img id="read-device-post-loading-spinner" src="{{pathVal}}dash-spinner.gif" class="dash-border text-secondary custom-spinner" alt="">
    }
    @if (noReader && !specialErrorNoDatabase) {
      <div class="center-text signifyBoldlg" style="white-space: pre-line;">{{errorMessage}}</div>
    }
    @if (allCorruptFeatureNotSelected) {
      <div class="center-text signifyBoldlg" style="white-space: pre-line;">{{errorMessage}}</div>
    }
    @if (showRetryOwpButton || changedDEVICE) {
      <div  class="center-text signifyBoldlg" style="white-space: pre-line;">{{errorMessage}}</div>
    }
    @if (wrongReader || readerPresence) {
      <div  class="center-text signifyBoldlg" style="white-space: pre-line;">{{errorMessage}}</div>
    }
    <!--  Special Case -->
    @if (noReader && specialErrorNoDatabase) {
      <div class="signifyBoldlg row">
        <div class="col-3"></div>
        <div class="col-9">This device is not found in our database:</div>
      </div>
      }<br>
      @if (noReader && specialErrorNoDatabase) {
        <div class="row">
          <div class="col-3"></div>
          <div class="col-9"><span class="signifyBoldsm">Device: </span><span
        class="signifyBooksm">{{readerDeviceData?.deviceMetadata?.deviceName}}</span>
      &nbsp;{{readerDeviceData?.deviceMetadata?.deviceSwVersion}}</div>
    </div>
  }
  @if (noReader && specialErrorNoDatabase) {
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9">
        <span class="signifyBoldsm">12nc: </span><span
      class="signifyBooksm">{{readerDeviceData?.deviceMetadata?.device12nc}}</span>
    </div>
  </div>
  }<br>
  @if (noReader && specialErrorNoDatabase) {
    <div class="signifyBoldlg row">
      <div class="col-3"></div>
      <div class="col-9">Please choose another device!</div>
    </div>
  }
  <!--  Special Case -->
  <div class="status-bottom-right">
    @if (noReader) {
      <div id="read-device-simpleset-disconnected" class="center-text signifyBoldlg">
        <span class="signifyBooklg">| SimpleSet disconnected </span>
        <img class="img-size" src="{{pathVal}}disconnected_icon.png" alt="Connected">
      </div>
    }
    @if ((readerData && hideStatus && isDeviceConnected)||wrongReader ||readerPresence) {
      <div
        id="read-device-simpleset-connected" class="center-text signifyBoldlg">
        <span class="signifyBooklg">| SimpleSet connected </span>
        <img class="img-size" src="{{pathVal}}Connected_icon.png" alt="Connected">
      </div>
    }
  </div>
</div>
<div class="col-5"></div>
</div>
<div>
  <div class="col-7 d-flex justify-content-end flex-row no-padding-end button-group-no-gap">
    @if (retryButton || deviceCNtMatched || nextSuccessMultiWrite) {
      <div></div>
    }
    @if (!retryButton && !deviceCNtMatched && !nextSuccessMultiWrite) {
      <div></div>
    }
    @if (retryButton || deviceNotMatching) {
      <button id="read-device-retry-button" (click)="[activemodal.dismiss('Cross click'), retry()]" class="btn retry-btn"
        type="button">Retry
      </button>
    }
    @if (incorrectBoxSize || owpProtectedMultiDevices ) {
      <button id="read-device-retry-nextsuccess-button" (click)="[activemodal.dismiss('Cross click'),nextSuccessMultiWrite()]" class="btn retry-btn"
        type="button">Retry
      </button>
    }
    @if (showRetryOwpButton) {
      <button id="read-device-retry-owp-button" (click)="openOwpPasswordPopup()" class="btn retry-btn"
        type="button">Retry
      </button>
    }
    @if ((showNextSuccessWriteBtn && !nextClicked) || incorrectBoxSize || deviceNotMatching || (wrongReader && isShowCancelBtn) ||(isShowCancelBtn && showRetryOwpButton) || (!writingDevicesContainer && retryButton && isShowCancelBtn) || allCorruptFeatureNotSelected) {
      <button id="read-device-cancel-button" type="button" class="btn prev-btn"
      (click)="[activemodal.dismiss('Cross click'), cancel()]">Cancel</button>
    }
    @if (showNextSuccessWriteBtn && !deviceCNtMatched && !incorrectBoxSize && !owpProtectedMultiDevices && !deviceNotMatching && !changedDEVICE && !showRetryOwpButton && !retryButton && !nextClicked) {
      <button id="read-device-next-button" [disabled]="nextClicked" class="btn retry-btn"  type="button"
      (click)="[activemodal.dismiss('Cross click'),retry()]">Next</button>
    }
  </div>
</div>
</div>
</div>
</div>
}

<!---End of Read device-->
